import { render, staticRenderFns } from "./UserChAttr.vue?vue&type=template&id=610dd932&scoped=true"
import script from "./UserChAttr.vue?vue&type=script&lang=js"
export * from "./UserChAttr.vue?vue&type=script&lang=js"
import style0 from "./UserChAttr.vue?vue&type=style&index=0&id=610dd932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610dd932",
  null
  
)

export default component.exports